import { createAsyncThunk } from '@reduxjs/toolkit';

import { getChatService, updateChatService } from 'services/chat.service';

import { GetChatProps, UpdateChatProps } from 'entities/Chat';

export const getChat = createAsyncThunk(
  'chat/getChat',
  async (data: GetChatProps, thunkApi) => {
    try {
      const response = await getChatService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateChat = createAsyncThunk(
  'chat/updateChat',
  async (data: UpdateChatProps, thunkApi) => {
    try {
      const response = await updateChatService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
